"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeleteRangePermissionHistoryItem = exports.CreateRangePermissionHistoryItem = exports.RangePermissionHistoryItemBase = void 0;
var tslib_1 = require("tslib");
var history_item_1 = require("../base/history-item");
var RangePermissionHistoryItemBase = (function (_super) {
    tslib_1.__extends(RangePermissionHistoryItemBase, _super);
    function RangePermissionHistoryItemBase(modelManipulator, boundSubDocument, bkmTemplate) {
        var _this = _super.call(this, modelManipulator) || this;
        _this.permissionTemplate = bkmTemplate;
        _this.boundSubDocument = boundSubDocument;
        return _this;
    }
    return RangePermissionHistoryItemBase;
}(history_item_1.HistoryItem));
exports.RangePermissionHistoryItemBase = RangePermissionHistoryItemBase;
var CreateRangePermissionHistoryItem = (function (_super) {
    tslib_1.__extends(CreateRangePermissionHistoryItem, _super);
    function CreateRangePermissionHistoryItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CreateRangePermissionHistoryItem.prototype.redo = function () {
        this.modelManipulator.rangePermission.createRangePermission(this.boundSubDocument, this.permissionTemplate);
    };
    CreateRangePermissionHistoryItem.prototype.undo = function () {
        this.modelManipulator.rangePermission.deleteRangePermission(this.boundSubDocument, this.permissionTemplate);
    };
    return CreateRangePermissionHistoryItem;
}(RangePermissionHistoryItemBase));
exports.CreateRangePermissionHistoryItem = CreateRangePermissionHistoryItem;
var DeleteRangePermissionHistoryItem = (function (_super) {
    tslib_1.__extends(DeleteRangePermissionHistoryItem, _super);
    function DeleteRangePermissionHistoryItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DeleteRangePermissionHistoryItem.prototype.redo = function () {
        this.modelManipulator.rangePermission.deleteRangePermission(this.boundSubDocument, this.permissionTemplate);
    };
    DeleteRangePermissionHistoryItem.prototype.undo = function () {
        this.modelManipulator.rangePermission.createRangePermission(this.boundSubDocument, this.permissionTemplate);
    };
    return DeleteRangePermissionHistoryItem;
}(RangePermissionHistoryItemBase));
exports.DeleteRangePermissionHistoryItem = DeleteRangePermissionHistoryItem;
